import { Component, Host, h, Element } from '@stencil/core';

export interface AhaCardRow extends HTMLAhaCardRowElement {}

/**
 * Starter component
 * @slot default - Contents of the default slot.
 */
@Component({
  tag: 'aha-card-row',
  styleUrl: 'aha-card-row.css',
  shadow: true,
})
export class AhaCardRow {
  @Element() host!: HTMLAhaCardRowElement;
  render() {
    return (
      <Host>
        <slot></slot>
      </Host>
    );
  }
}
